import { Box, Drawer, Stack, Typography, List, Divider, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import ImageFromBase64 from "../../components/imageProfile";
import API from "../../api";
import { useLocation } from "react-router-dom";
import Item from "../../components/SidebarItem";
import MenuIcon from '@mui/icons-material/Menu';
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import FolderIcon from '@mui/icons-material/Folder';
import { LicenseIcon } from "../../components/GeneralIcons";

const SidebarC = ({ isCollapsed, handleChange }) => {
  const location = useLocation();
  const [drawerWidth, setDrawerWidth] = useState(isCollapsed ? 80:240);
  const [image, setImage] = useState();
  const [imageType, setImageType] = useState();
  const [companyName, setCompanyName] = useState();
  const [nome, setNome] = useState();
  const [cognome, setCognome] = useState();
  const [selected, setSelected] = useState(location.pathname);

  const pages = [
    { data: { icon: <HomeOutlinedIcon />, title: "Overview", to: "/reseller/home" } },
    { data: { title: "Partner Management" } },
    { data: { icon: <AdminPanelSettingsRoundedIcon />, title: "Deal Protection", to: "/reseller/deal-protection" } },
    { data: { icon: <LicenseIcon />, title: "License Management", to: "/reseller/licenses" } },
    { data: { title: "Support" } },
    { data: { icon: <FolderIcon />, title: "Documentations", to: "/reseller/document" } },
  ];

  useEffect(() => {
    if (sessionStorage.getItem('ragioneSociale') && sessionStorage.getItem('nomeUser') && sessionStorage.getItem('cognomeUser')) {
      setImage(sessionStorage.getItem('profileImage') || "");
      setCompanyName(sessionStorage.getItem('ragioneSociale') || "");
      setImageType(sessionStorage.getItem('imageType') || "");
      setNome(sessionStorage.getItem('nomeUser') || "");
      setCognome(sessionStorage.getItem('cognomeUser') || "");
    } else {
      API.getDataUsers().then((result) => {
        setImage(result.data.profileImage);
        setCompanyName(result.data.ragioneSociale);
        setImageType(result.data.imageType);
        setNome(result.data.nome);
        setCognome(result.data.cognome);
        sessionStorage.setItem("profileImage", result.data.profileImage);
        sessionStorage.setItem("ragioneSociale", result.data.ragioneSociale);
        sessionStorage.setItem("imageType", result.data.imageType);
        sessionStorage.setItem("nomeUser", result.data.nome);
        sessionStorage.setItem("cognomeUser", result.data.cognome);
      }).catch((error) => {
        console.error('[SidebarC] error:', error);
      });
    }
  }, []);

  useEffect(() => {
    if (isCollapsed) setDrawerWidth(80);
    else setDrawerWidth(240);
  }, [isCollapsed]);

  return(
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": { width: drawerWidth }
      }}
    >
      <Stack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'top'} height={'100%'} minWidth={0} width={"100%"}>
        {!isCollapsed ? (
          <>
            <img
              src="/logo-lecs.png"
              alt="LECS"
              style={{ width: "auto", height: "50px", alignSelf: "start" }}
            />

            <Box sx={{ display: "flex", width: "max-content", borderRadius: "50%" }}>
              <ImageFromBase64 base64Data={image} format={imageType} style={{ width: "100px" }} />
            </Box>

            <Typography variant="h4" fontWeight="bold">
              {companyName}
            </Typography>

            <Typography variant="h6">
              {nome} {cognome}
            </Typography>
          </>
        ) : (
          <Box sx={{ display: "flex", width: "max-content", backgroundColor: 'transparent', borderRadius: "50%", pt: 5 }}>
            <ImageFromBase64 base64Data={image} format={imageType} style={{ width: "50px", height: "50px" }} />
          </Box>
        )}

        <Box height={"100%"} overflow={"auto"} px={2} minWidth={0} width={"100%"}>
          <List>
            {
              pages.filter(page => page != null).map((page, index) => (
                <Item
                  key={index}
                  data={page.data}
                  header={page?.header}
                  isCollapsed={isCollapsed}
                  selected={selected}
                  setSelected={setSelected}
                />
              ))
            }
          </List>
        </Box>

        <Divider flexItem />
        <Stack direction={"row"} spacing={1} p={1.5} width={"100%"} justifyContent={isCollapsed ? 'center' : 'flex-end'} alignItems={"center"}>
          <IconButton onClick={() => handleChange()}>
            {isCollapsed ? <MenuIcon /> : <ArrowBackIosNewIcon />}
          </IconButton>
        </Stack>
      </Stack>
    </Drawer>
  )
};

export default SidebarC;

/*
return (
    <Box
      sx={{
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: aiView ? "#774caa !important" : "#73ccd7 !important",
        },
        "& .pro-menu-item.active": {
          color: aiView ? "#5E3F82 !important" : "#52a0a6 !important",
        },
      }}
    >

      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          <Box display="flex" alignItems="center" ml="15px">
            <Box>
              {isCollapsed ? (
                <img
                  src="/logoWhite.png"
                  alt="LECS"
                  style={{ width: "auto", height: "50px" }}
                />
              ) : (
                <img
                  src="/logo-lecs.png"
                  alt="LECS"
                  style={{ width: "auto", height: "50px" }}
                />
              )}
            </Box>
            <Box>
              <IconButton
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                disableRipple
                id="buttonSideBar"
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                  position: "fixed", // Il pulsante è posizionato in modo fisso
                  top: "50%", // Centrato verticalmente
                  left: isCollapsed ? "72px" : "260px", // Distanza dal bordo sinistro in base allo stato della sidebar
                  transform: "translateY(-50%)", // Centra il pulsante verticalmente
                  zIndex: 1000, // Assicurati che sia sopra agli altri elementi
                }}
              >
                {hover ? (
                  isCollapsed ? (
                    <ArrowForwardIosIcon />
                  ) : (
                    <ArrowBackIosNewIcon />
                  )
                ) : (
                  <HorizontalRuleIcon style={{ rotate: "90deg" }} />
                )}
              </IconButton>
            </Box>
          </Box>

          {!isCollapsed && (
            <Box mb="25px" sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <Box sx={{ display: "flex", width: "max-content", backgroundColor: "#eaeaea", borderRadius: 100 }}>
                {<ImageFromBase64 base64Data={image} format={imageType} />}
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {companyName}
                </Typography>
                <Typography variant="h5" color={colors.grey[100]}>
                  {nome} {cognome}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <Item
              title="Overview"
              to="/reseller/home/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Partner Management
            </Typography>
              <Item
                title="Deal Protection"
                to="/reseller/deal-protection"
                selected={selected}
                setSelected={setSelected}
                icon={<AdminPanelSettingsRoundedIcon />}
              />
              <Item
                title="License Management"
                to="/reseller/licenses"
                selected={selected}
                setSelected={setSelected}
                icon={<LicenseIcon />}
              />

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Support
            </Typography>           
            <Item
              title="Documentations"
              to="/reseller/document"
              selected={selected}
              setSelected={setSelected}
              icon={<FolderIcon />}
            />
            {icos === 'producer' &&
              <Item
                title="Produce Lecs"
                to="/reseller/produce"
                selected={selected}
                setSelected={setSelected}
                icon={<AddCircleOutlineRoundedIcon />}
              />
            }

          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
*/